export default __webpack_public_path__ + "static/media/spinner.63e70bc8.png";